import React from "react";

const PlanSelector = ({ plans, active, onSelect, t }) => {
  return (
    <div className="mb-6 grid grid-cols-3 gap-3">
      {plans.map((plan) => (
        <button
          type="button"
          key={plan.id}
          onClick={() => onSelect(plan.id)}
          className={`cursor-pointer rounded-xl border p-3 text-center transition ${
            active === plan.id
              ? "border-primary bg-primary/10"
              : "hover:border-primary border-gray-300"
          }`}
        >
          <p className="text-primary font-medium">
            {t(`pricing.${plan.label}`)}
          </p>

          <p className="text-xs text-gray-500">{t(plan.billedKey)}</p>

          {plan.discount && (
            <p className="mt-1 text-xs text-green-600">
              {t("pricing.save")} {plan.discount}
            </p>
          )}
        </button>
      ))}
    </div>
  );
};

export default PlanSelector;
